<template>
    <div class="container-fluid">
        <div class="row py-3">
            <div class="designRowOrga">
                <div class="h3Organization ">
                    <h3>Competitions</h3>
                </div>
                <div class="btnOrganization">
                    <div v-if="(searchFlag) || permissions.includes('create competition')  ">
                        <button @click.prevent="CreateCompetition">
                            Create Competition
                        </button>
                    </div>
                    <div v-else></div>
                </div>
            </div>
            <div class="tab p-0">
                <router-link class="text-decoration-none tablinks h2 m-0" to="/competitions" >New</router-link>
                <router-link class="text-decoration-none tablinks h2 m-0 active" to="/completed/competition">Completed</router-link>
            </div>

            <div class="tabcontent">
                <div class="fullInputs mb-4 ">
                    <div class="twoInputs">
                        <div class="btnInsideInput" >
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                   placeholder="Search" autocomplete="off"
                                   @input="searchCompetition" maxlength="50">

                            <button @click="searchBackEndHandler(isSearch, 1)" ref="buttonSearch">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                        </div>

                        <div class="btnSearchAll" :style="role === 'user' ? {display: 'none'}  : {display: 'block'} ">
<!--                            <button id="searchAll" class="form-control" ref="buttonSearch" @click="getCompetitions">-->
<!--                                <img src="../../../assets/images/SearchIcon.png" alt="">-->
<!--                            </button>-->
                        </div>
                    </div>
                    <div class="oneInput">
                        <select id="filter_dates" class="form-select" v-model="sort" @change="getCompetitions">
                            <option :value="null" disabled selected >Sort by Date</option>
                            <option value="asc">Oldest</option>
                            <option value="desc">Latest</option>
                        </select>
                    </div>
                </div>

                <div class="table-container" v-if="competitions.length > 0">

                    <TableComponent :thead="role === 'user' ? theadUser : thead" :tbody="competitions"
                                    @sort="SortCompetition" :keys="role === 'user' ? keysUser : keys"
                                    model="competitions" name="competition"
                                    updateUrl="/complete-edit-competitions" :ids="competitions_ids"
                                    @update="updateCompetition"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getCompetitions" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>

                <div v-else class="text-center d-flex flex-column justify-content-center align-items-center h-75 m-auto">
                    <div class="mb-4">
                        <h2 v-if="!searchFlag" class="">You Don't Have Any Completed Competition Yet</h2>
                        <h2 v-else class="">No Data</h2>
                    </div>
<!--                    <div>-->
<!--                        <button class="btn cssBtnCreateCompetition" v-if="permissions.includes('create competition') && !searchFlag" @click.prevent="CreateCompetition">Create-->
<!--                            Competition-->
<!--                        </button>-->
<!--                    </div>-->
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from "laravel-vue-pagination";
    import competition from "../../../api-services/competition";

    export default {
        name: 'completed-competition',
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'competition');
            this.permissions = this.$store.state.auth.permissions;
            this.role = this.$store.state.auth.user.data.role[0];
            this.getCompetitions();
        },
        data() {
            return {
                thead: ['Competition Name', 'Type', 'Status'],
                keys: ['name', 'type', 'status'],
                theadUser: ['Competition Name', 'Type', 'Status'],
                keysUser: ['name', 'type', 'status'],
                permissions: [],
                competitions: [],
                filteredArray: [],
                originalCompetitions: [],
                laravelData: {},
                error: null,
                search: '',
                searchFlag: false,
                sort: null,
                status: null,
                status2: false,
                score: false,
                role: ''
            }
        },
        methods: {
            CreateCompetition() {
                this.$router.push({name: 'create-competition'});
            },
            async getCompetitions(page = 1) {
                if (this.permissions.includes('viewAny competition')) {
                    try {
                        const response = await competition.getCompletedCompetitionAdmin(this.search, this.sort === false ? this.sort = 'asc' : this.sort, page , 'ended');
                        this.competitions = response.data.data;
                        this.laravelData = response.data;
                        this.originalCompetitions = response.data.data;
                    } catch (e) {
                        console.log(e);
                        this.error = e;
                    }
                } else {
                    try {
                        const response = await competition.getAssignedCompetitionsOfUsersCompleted(this.search, this.sort === false ? this.sort = 'asc' : this.sort, page , 'ended');
                        this.competitions = response.data.data;
                        this.laravelData = response.data;
                        this.originalCompetitions = response.data.data;
                    } catch (e) {
                        console.log(e);
                        this.error = e;
                    }
                }
            },
            // async getNewCompetition(){
            //     this.$router.push({name: 'competition'});
            // },
            async getCompletedCompetition(page=1){
                if (this.role !== 'user') {
                    try {
                        const response = await competition.index(this.search, this.status, this.sort === false ? this.sort = 'asc' : this.sort, page);
                        this.competitions = response.data.data;
                        this.laravelData = response.data;
                        this.originalCompetitions = response.data.data;
                    } catch (e) {
                        console.log(e);
                        this.error = e;
                    }
                } else {
                    try {
                        const response = await competition.getAssignedCompetitionsOfUsers();
                        this.competitions = response.data.data;
                        this.laravelData = response.data;
                        this.originalCompetitions = response.data.data;
                    } catch (e) {
                        console.log(e);
                        this.error = e;
                    }
                }
            },
            async SortCompetition() {
                let status = !this.status2;
                this.originalCompetitions.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.status2 = status;
            },
            async updateCompetition(e) {
                let filteredData = this.competitions.filter(function (data) {
                    return data.id != e;
                });
                this.competitions = filteredData;
            },
            async competitions_ids() {
                try {
                    const response = await competition.index();

                } catch (e) {
                    console.log(e);
                }
            },
            searchCompetition(e) {
                let searchedValue = e.target.value;
                let searchedData = this.originalCompetitions.filter((data) => data.name.includes(searchedValue));
                this.competitions = searchedData;
                this.searchFlag = true;
            },
            async searchBackEndHandler(searchFlag = true) {
                await this.getCompetitions();
            },
        }
    }
</script>

<style scoped>
    .designRowOrga {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0px;
        margin-bottom: 20px;
    }

    .btnOrganization button {
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: none;
        border-radius: 5px;
        justify-content: end;
        align-content: center;
        padding: 10px;
    }

    .cssBtnCreateCompetition {
        background-color: #E95626;
        color: #fff;
        border-radius: 10px;
        width: 200px;
        padding: 10px;
    }

    .cssNoCompetitions {
        padding: 140px;
    }

    /*.btnInsideInput {*/
    /*    display: flex;*/
    /*    flex-direction: row;*/
    /*    border: 1px solid #FFF;*/
    /*    border-radius: 3px;*/
    /*}*/

    /*.btnInsideInput input {*/
    /*    border: none;*/
    /*}*/

    /*.btnInsideInput button {*/
    /*    background-color: #032431;*/
    /*    border: none;*/
    /*}*/

    /*.twoInputs #free_search {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 350px;*/
    /*}*/

    .btnSearchAll #searchAll {
        background-color: #e65c00;
        color: #fff;
        width: 45px;
        padding-left: 0px;
        padding-right: 0px;
        border-color: #e65c00;
    }

    .getScore #statusScore {
        background-color: #032431;
        color: #fff;
        width: 350px;
    }

    /*.getStatus #statusSeacrh {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 350px;*/
    /*}*/

    /*.oneInput #filter_dates {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 220px;*/
    /*}*/

    .twoInputs {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        gap: 20px;
    }

    .fullInputs {
        display: flex;
    }

    .fullInputs {
        justify-content: space-between;
    }

    /*.tabcontent {*/
    /*    border: 1px solid #032431;*/
    /*    background-color: #032431;*/
    /*    border-radius: 20px;*/
    /*    padding: 23px;*/
    /*}*/

    .tab {
        overflow: hidden;
    }

    /*.tab .tablinks {*/
    /*    background-color: inherit;*/
    /*    color: #fff;*/
    /*    float: left;*/
    /*    border: none;*/
    /*    outline: none;*/
    /*    cursor: pointer;*/
    /*    padding: 14px 5px;*/
    /*    transition: 0.3s;*/
    /*    font-size: 17px;*/
    /*}*/

    /*.tab .tablinks:hover,*/
    /*.tab .tablinks.active {*/
    /*    background-image: linear-gradient(#044D6B, #021A24);*/
    /*    color: #E37450;*/
    /*    border-radius: 10px 10px 0px 0px;*/
    /*}*/

    /*.tabcontent {*/
    /*    display: block;*/
    /*    padding: 30px;*/
    /*    height: 70vh;*/
    /*    border-top: none;*/
    /*    background-image: linear-gradient(#16303a, #021A24);*/
    /*    border-radius: 0 20px 20px 20px;*/
    /*}*/

    .setting-action {
        text-decoration: none;
        cursor: pointer;
        background-color: #E95626;
        border-radius: 10px;
        color: #FFF;
        border-radius: 4px;
        font-weight: 500;
        padding: 12px 55px;
        font-size: 18px;
        height: fit-content;
    }


    .setting-action:hover {
        color: #FFF;
    }

    /* we will explain what these classes do next! */
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }

    .back-route {
        text-decoration: none;
        cursor: pointer;
        color: #FFF;
        font-size: 22px;
    }

    .back-route:hover {
        color: #FFF;
    }
</style>